import Serializer from 'umg-ember-backend/serializers/application';

export default class AudioplayerShopSerializer extends Serializer {
  attrs = {
    position: 'cmsPosition',
  };
}
